@if (regimen()) {
  <div class="tw-relative tw-w-full tw-flex tw-items-center tw-justify-between tw-overflow-hidden tw-p-3 tw-rounded-3 tw-shadow-z4 tw-bg-orange-35">
    <!-- Discount badge -->
    @if (discount()) {
      <div class="tw-absolute tw-top-0 tw-left-3 tw-bg-orange-500 tw-text-white tw-font-lexend tw-font-bold tw-text-50 tw-px-1.5 tw-rounded-b-1 tw-overflow-hidden">
        {{ discount() }}% OFF
      </div>
    }

    <!-- Left content -->
    <div class="tw-flex tw-flex-col tw-gap-3 tw-items-start tw-mt-4 sm:tw-mt-0">
      <span class="tw-font-lexend tw-font-bold tw-text-500 tw-text-black">
        <span i18n="@@fullTreatmenPlan">Full Treatment Plan</span> &#64;{{ regimen()?.fixedPrice }}
      </span>
      <button csButton
              size="small"
              class="tw-px-7 tw-m-0"
              (click)="onBuyKit()">
        <span class="tw-text-300" i18n="@@buyCompleteKit">Buy Complete Kit</span>
      </button>
    </div>

    <!-- Right image -->
    <div class="tw-bg-white tw-h-28 tw-w-24 tw-rounded-3 tw-overflow-hidden tw-shrink-0">
      <img [src]="regimen()?.regimenCoverImage" alt="Regimen Kit" class="tw-object-cover tw-w-full tw-h-full" />
    </div>
  </div>
}
